export const rows =[
  {
    "support": 0.03,
    "itemsets": "['tropical fruit', 'citrus fruit']",
    "length": 2,
    "id": 1
  },
  {
    "support": 0.03,
    "itemsets": "['whole milk', 'citrus fruit']",
    "length": 2,
    "id": 2
  },
  {
    "support": 0.03,
    "itemsets": "['yogurt', 'tropical fruit']",
    "length": 2,
    "id": 3
  },
  {
    "support": 0.03,
    "itemsets": "['whole milk', 'tropical fruit']",
    "length": 2,
    "id": 4
  },
  {
    "support": 0.04,
    "itemsets": "['other vegetables', 'tropical fruit']",
    "length": 2,
    "id": 5
  },
  {
    "support": 0.03,
    "itemsets": "['rolls/buns', 'tropical fruit']",
    "length": 2,
    "id": 6
  },
  {
    "support": 0.03,
    "itemsets": "['root vegetables', 'tropical fruit']",
    "length": 2,
    "id": 7
  },
  {
    "support": 0.03,
    "itemsets": "['tropical fruit', 'brown bread']",
    "length": 2,
    "id": 8
  },
  {
    "support": 0.06,
    "itemsets": "['yogurt', 'whole milk']",
    "length": 2,
    "id": 9
  },
  {
    "support": 0.03,
    "itemsets": "['yogurt', 'cream cheese']",
    "length": 2,
    "id": 10
  },
  {
    "support": 0.03,
    "itemsets": "['yogurt', 'bottled water']",
    "length": 2,
    "id": 11
  },
  {
    "support": 0.03,
    "itemsets": "['yogurt', 'soda']",
    "length": 2,
    "id": 12
  },
  {
    "support": 0.07,
    "itemsets": "['other vegetables', 'whole milk']",
    "length": 2,
    "id": 13
  },
  {
    "support": 0.03,
    "itemsets": "['butter', 'whole milk']",
    "length": 2,
    "id": 14
  },
  {
    "support": 0.03,
    "itemsets": "['whole milk', 'rolls/buns']",
    "length": 2,
    "id": 15
  },
  {
    "support": 0.04,
    "itemsets": "['curd', 'whole milk']",
    "length": 2,
    "id": 16
  },
  {
    "support": 0.04,
    "itemsets": "['whole milk', 'soda']",
    "length": 2,
    "id": 17
  },
  {
    "support": 0.03,
    "itemsets": "['sugar', 'whole milk']",
    "length": 2,
    "id": 18
  },
  {
    "support": 0.03,
    "itemsets": "['pastry', 'whole milk']",
    "length": 2,
    "id": 19
  },
  {
    "support": 0.04,
    "itemsets": "['root vegetables', 'whole milk']",
    "length": 2,
    "id": 20
  },
  {
    "support": 0.03,
    "itemsets": "['whole milk', 'domestic eggs']",
    "length": 2,
    "id": 21
  },
  {
    "support": 0.05,
    "itemsets": "['other vegetables', 'rolls/buns']",
    "length": 2,
    "id": 22
  },
  {
    "support": 0.03,
    "itemsets": "['other vegetables', 'bottled water']",
    "length": 2,
    "id": 23
  },
  {
    "support": 0.05,
    "itemsets": "['other vegetables', 'root vegetables']",
    "length": 2,
    "id": 24
  },
  {
    "support": 0.03,
    "itemsets": "['whipped/sour cream', 'other vegetables']",
    "length": 2,
    "id": 25
  },
  {
    "support": 0.04,
    "itemsets": "['bottled water', 'rolls/buns']",
    "length": 2,
    "id": 26
  },
  {
    "support": 0.05,
    "itemsets": "['rolls/buns', 'soda']",
    "length": 2,
    "id": 27
  },
  {
    "support": 0.03,
    "itemsets": "['sugar', 'rolls/buns']",
    "length": 2,
    "id": 28
  },
  {
    "support": 0.04,
    "itemsets": "['root vegetables', 'rolls/buns']",
    "length": 2,
    "id": 29
  },
  {
    "support": 0.05,
    "itemsets": "['sausage', 'rolls/buns']",
    "length": 2,
    "id": 30
  },
  {
    "support": 0.03,
    "itemsets": "['pastry', 'soda']",
    "length": 2,
    "id": 31
  },
  {
    "support": 0.03,
    "itemsets": "['fruit/vegetable juice', 'brown bread']",
    "length": 2,
    "id": 32
  },
  {
    "support": 0.03,
    "itemsets": "['canned beer', 'brown bread']",
    "length": 2,
    "id": 33
  },
  {
    "support": 0.03,
    "itemsets": "['shopping bags', 'canned beer']",
    "length": 2,
    "id": 34
  },
  {
    "support": 0.03,
    "itemsets": "['whipped/sour cream', 'pork']",
    "length": 2,
    "id": 35
  }
];